import '../../../../../../resources/app/bootstrap.js';
import { createApp } from 'vue';
import store from './stores/store';
import gpApp from '../../../../../../resources/app/utils/plugins/gpApp.js';
import gpUtils from "../../../../../../resources/app/utils/plugins/gpUtils.js";
import formOrder from '../../../../../../resources/app/modules/product/views/order/formOrder.vue';
import reviewOrder from '../../../../../../resources/app/modules/product/views/order/reviewOrder.vue';
import shoppingCart from '../../../../../../resources/app/modules/product/views/order/shoppingCart.vue';
import viewInvoice from '../../../../../../resources/app/modules/product/views/invoice/viewInvoice.vue';

export function createFormOrder(elementId, props = {}) {
    const app = createApp(formOrder, {
        ...props,
        isStandalone: true
    });

    app.use(gpApp);
    app.use(gpUtils);
    app.use(store);
    return app.mount(elementId);
}

export function createReviewOrder(elementId, props = {}) {
    const app = createApp(reviewOrder, {
        ...props,
        isStandalone: true
    });

    app.use(gpApp);
    app.use(gpUtils);
    app.use(store);
    return app.mount(elementId);
}

export function createShoppingCart(elementId, props = {}) {
    const app = createApp(shoppingCart, {
        ...props,
        isStandalone: true
    });

    app.use(gpApp);
    app.use(gpUtils);
    app.use(store);
    return app.mount(elementId);
}

export function createViewInvoice(elementId, props = {}) {
    const app = createApp(viewInvoice, {
        ...props,
        isStandalone: true
    });

    app.use(gpApp);
    app.use(gpUtils);
    app.use(store);
    return app.mount(elementId);
}

// Make the function available globally
if (typeof window !== 'undefined') {
    window.createFormOrder = createFormOrder;
    window.createReviewOrder = createReviewOrder;
    window.createShoppingCart = createShoppingCart;
    window.createViewInvoice = createViewInvoice;
}
